module.exports = __webpack_public_path__ + "img/ejoy_logo.6423d09a.svg";